import { inject, Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { ActiveUserStore } from '../stores/user/active-user.state';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  readonly userStore = inject(ActiveUserStore);

  canActivate() {
    return this.userStore.checkAuthStatus(); // Leverage the centralized store logic
  }

  // Child route guardian
  canActivateChild() {
    return this.canActivate(); // Reuse the same logic as `canActivate`
  }
}
